import React, { useEffect, useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSnackbar } from "../../components/SnackbarProvider";
import TopBar from "../../components/TopBar";
import {
  useConfirmAccountSetupIntent,
  useUpdateAccount,
} from "../hooks/queries";
import { useActiveAccount } from "../hooks/useAccounts";

export default SetupIntentCallback;

export function SetupIntentCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { activeAccount } = useActiveAccount();

  const { setupIntent, selectedPlan } = useMemo(() => {
    const setupIntent = searchParams.get("setup_intent");
    const selectedPlan = searchParams.get("selected_plan");
    if (selectedPlan === "on_demand") {
      return {
        setupIntent,
        selectedPlan: selectedPlan as "on_demand",
      };
    }
    return { setupIntent };
  }, []);

  const { mutateAsync: confirmAccountSetupIntent } =
    useConfirmAccountSetupIntent();

  const showSnackbar = useSnackbar();

  const { mutateAsync: updateAccount } = useUpdateAccount(activeAccount.name, {
    onSuccess: () => {
      showSnackbar({
        title: `Account plan successfully upgraded`,
        severity: "success",
      });
    },
    onError: () => {
      showSnackbar({
        title: `Account plan upgraded failed`,
        severity: "error",
      });
    },
  });

  useEffect(() => {
    confirmAccountSetupIntent(setupIntent)
      .then(() => {
        if (selectedPlan) {
          return updateAccount({
            subscription: { plan_id: selectedPlan },
          });
        }
      })
      .then(() => {
        navigate("../account?tab=billing");
      });
  }, []);

  return <TopBar isLoading />;
}
